export { default } from './skeleton';
